const ExpandIcon = () => (<svg width="34" height="17" viewBox="0 0 34 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.333496 0.333496L17.0002 17.0002L33.6668 0.333496H0.333496Z" fill="white" />
</svg>)

export default ExpandIcon